module.exports = __webpack_public_path__ + "static/media/icon-double-caret-prev.b8497d68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-double-caret-prev.svg
// module id = 1236
// module chunks = 19